// This file has been generated from LT.Core.Logic.Search.SearchOrderingOption
export enum SearchOrderingOption {

  
   Default = 0,
   PriceAsc = 11,
   PriceDesc = 12,
   MaxGuestCountAsc = 21,
   MaxGuestCountDesc = 22

}
export default SearchOrderingOption;